<template>
    <RichTextEditor
        class="text-editor"
        v-model="model"
        :readingMode="!isEditing"
    />
</template>
<script setup lang="ts">
import { Artefact } from "@/lib/artefacts";
import RichTextEditor from "@/components/RichTextEditor.vue";

const model = defineModel<Artefact>({ required: true });
defineProps<{
    isEditing: boolean;
}>();
</script>

<style lang="scss">
c-text-editor {
    &::part(editor-document-edit-mode) {
        padding-top: 1em;
        padding-bottom: 1em;
    }
    &::part(node-heading-1),
    &::part(node-heading-2) {
        font-weight: normal;
        border-bottom: unset;
    }
}
</style>
